<template>
  <div class="notfind">
    <!-- 头部 -->
    <v-header></v-header>
    <div class="not">
      <img src="../assets/images/notfind.jpg" alt="" />
    </div>
  </div>
</template>

<script>
import header from "../components/header";
export default {
  name: "notfind",
  data() {
    return {};
  },
  components: {
    "v-header": header,
  }
};
</script>

<style>
.notfind > .not {
  margin: 110px auto 0 auto;
}
.notfind .not img {
  width: 100%;
}
@media (max-width: 780px) {
  .notfind > .not {
    margin: 135px 0 0 0;
  }
}
</style>
